import Vue from "vue";
import "./plugins/axios";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./assets/css/reset.css";
import "./assets/css/custom.min.css";
import "./assets/css/icon";
import "./assets/css/starrysky.css";
import "./plugins/element.js";
import "./plugins/echarts";
import "./assets/css/customAnimate.css";
import "./assets/css/animatePlugin.css";

import Layout from "./layout/install";
import LLoading from "./components/loading/loading";
import "./plugins/loading";
import Print from "vue-print-nb";
import "driver.js/dist/driver.min.css";
import "./plugins/step";
import { jsonp } from "vue-jsonp";
import MD5 from "md5";
Vue.use(Print);

Vue.config.productionTip = false;
Vue.use(Layout);

Vue.component("LLoading", LLoading);

Date.prototype.$Format = function(fmt) {
  //author: meizz
  var o = {
    "M+": this.getMonth() + 1, //月份
    "d+": this.getDate(), //日
    "h+": this.getHours(), //小时
    "m+": this.getMinutes(), //分
    "s+": this.getSeconds(), //秒
    "q+": Math.floor((this.getMonth() + 3) / 3), //季度
    S: this.getMilliseconds(), //毫秒
  };
  if (/(y+)/.test(fmt))
    fmt = fmt.replace(
      RegExp.$1,
      (this.getFullYear() + "").substr(4 - RegExp.$1.length)
    );
  for (var k in o)
    if (new RegExp("(" + k + ")").test(fmt))
      fmt = fmt.replace(
        RegExp.$1,
        RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length)
      );
  return fmt;
};

Vue.prototype.$openNewWindow = function(url, id) {
  let a = document.createElement("a");
  a.setAttribute("href", url);
  a.setAttribute("target", "_blank");
  a.setAttribute("id", id);
  // 防止反复添加
  if (!document.getElementById(id)) {
    document.body.appendChild(a);
  }
  a.click();
};

Vue.prototype.getDomTop = function getTop(e) {
  let offset = e.offsetTop;
  if (e.offsetParent != null) offset += getTop(e.offsetParent);
  return offset;
};

Vue.prototype.getDomLeft = function getLeft(e) {
  let offset = e.offsetLeft;
  if (e.offsetParent != null) offset += getLeft(e.offsetParent);
  return offset;
};

Vue.prototype.isBlur = (type) => {
  switch (type) {
    case true:
      document.querySelector("#app").classList.add("blur");
      break;
    case false:
      document.querySelector("#app").classList.remove("blur");
      break;
  }
};

Vue.prototype.animateCss = (
  element,
  animation,
  otherClass,
  reserveClass,
  prefix = "animate__"
) =>
  // We create a Promise and return it
  new Promise((resolve) => {
    const animationName = `${prefix}${animation}`;
    let node;
    if (typeof element.nodeName === "string" && element.nodeType === 1) {
      node = element;
    } else {
      node = document.querySelector(element);
    }

    node.classList.add(
      `${prefix}animated`,
      animationName,
      otherClass ? otherClass : "",
      reserveClass ? reserveClass : ""
    );

    // When the animation ends, we clean the classes and resolve the Promise
    function handleAnimationEnd(event) {
      event.stopPropagation();
      node.classList.remove(
        `${prefix}animated`,
        animationName,
        otherClass ? otherClass : ""
      );
      resolve("Animation ended");
    }

    node.addEventListener("animationend", handleAnimationEnd, {
      once: true,
    });
  });

Vue.prototype.$translateEn = (from, to, q) => {
  const url = "https://fanyi-api.baidu.com/api/trans/vip/translate/";
  const userinfo = {
    q: q,
    from: from,
    to: to,
    appid: "20240102001928615",
    salt: "89486546548",
    key: "1sYl2JYVqV1kKbK_rql_",
  };
  const generateSign = function() {
    return MD5(userinfo.appid + userinfo.q + userinfo.salt + userinfo.key);
  };
  const generateParams = `${url}?appid=${userinfo.appid}&q=${userinfo.q}&from=${
    userinfo.from
  }&to=${userinfo.to}&salt=${userinfo.salt}&sign=${generateSign()}`;
  return new Promise((resolve, reject) => {
    jsonp(generateParams).then((res) => {
      if (res) {
        resolve(res);
      } else {
        reject("");
      }
    });
  });
};
Vue.prototype.$languageFn = (q) => {
  const url = "https://fanyi-api.baidu.com/api/trans/vip/language/";
  const userinfo = {
    q: q,
    appid: "20240102001928615",
    salt: "89486546548",
    key: "1sYl2JYVqV1kKbK_rql_",
  };
  const generateSign = function() {
    return MD5(userinfo.appid + userinfo.q + userinfo.salt + userinfo.key);
  };
  const generateParams = `${url}?appid=${userinfo.appid}&q=${userinfo.q}&salt=${
    userinfo.salt
  }&sign=${generateSign()}`;
  return new Promise((resolve, reject) => {
    jsonp(generateParams).then((res) => {
      if (res) {
        console.log(res);
        resolve(res);
      } else {
        reject("");
      }
    });
  });
};

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
